import { render, staticRenderFns } from "./lecture-dialog.vue?vue&type=template&id=63b8863a"
import script from "./lecture-dialog.vue?vue&type=script&lang=js"
export * from "./lecture-dialog.vue?vue&type=script&lang=js"
import style0 from "./lecture-dialog.vue?vue&type=style&index=0&id=63b8863a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports